export default __webpack_public_path__ + "static/media/ios-cloud-upload.24ed1241.svg";